import { PlanSlug as ProductType } from '@manychat/paywall'

export { ProductType }

export const ProProducts = [ProductType.AUTOMATION, ProductType.INBOX] as const

export type ProProduct = typeof ProProducts[number]

export type RequiredProducts = ProductType[]
